webpackJsonp([166457285261563],{

/***/ 1259:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LabTrendStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"The result is on the job.","isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":"The engine could not generate this patient's trends.","isDeprecated":false,"name":"FAILED"},{"deprecationReason":null,"description":"Queued or running.","isDeprecated":false,"name":"PENDING"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-lab-trend-status-7dbd85e4b8d52f7631b7.js